import React from "react";
import Button, { ButtonSizes, ButtonThemes } from "../../../../ui-components/button/button";

export type TrendMetric = "count" | "value";

const OPTIONS: { value: TrendMetric; label: string }[] = [
  { value: "count", label: "Invoices" },
  { value: "value", label: "Value" },
];

/** Charts show one unit at a time, so counts and dollars never share an axis. */
const MetricToggle: React.FC<{ value: TrendMetric; onChange: (value: TrendMetric) => void }> = ({ value, onChange }) => (
  <div className="xgs-invoice-factoring__toggle" role="group" aria-label="Chart metric">
    {OPTIONS.map((option) => (
      <Button
        key={option.value}
        type="button"
        size={ButtonSizes.small}
        theme={option.value === value ? ButtonThemes.blue : ButtonThemes.blueInverted}
        aria-pressed={option.value === value}
        onClick={() => onChange(option.value)}
      >
        {option.label}
      </Button>
    ))}
  </div>
);

export default MetricToggle;
